// Support IE11
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import AppFrame from '4ff-lib-foundation/lib/AppFrame/publicAPI/components';
import { Tracker } from '4ff-lib-foundation/lib/AppFrame/publicAPI/events';
import { i18n } from '4ff-lib-foundation/lib/AppFrame/publicAPI/i18n';
import {
  getConfigFromMeta,
  getFieldFromMeta,
} from '4ff-lib-foundation/lib/AppFrame/publicAPI/config';

import history from './services/history';
import store from './store/configureStore';

import Root from './containers/Root';
import Redirect from './components/Redirect';
import PageNotFound from './components/PageNotFound';

import { themeSelector } from './themes';

const appContainer = document.getElementById('app');
if (!appContainer) {
  throw new Error('lpb-app-dashboard: missing root element #app');
}
const root = createRoot(appContainer);

function renderApp(config) {
  root.render(
    <Provider store={store}>
      <Router history={history}>
        <AppFrame
          theme={themeSelector(config.theme)}
          config={config}
          onLoaded={() => { history.push('/dashboard'); }}
          moduleName="Navigation"
          history={history}
        >
          <Switch>
            <Route path="/dashboard" component={Root} />
            <Route path="/redirect" component={Redirect} />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </AppFrame>
      </Router>
    </Provider>,
  );
}

const initApp = async () => {
  const config = getConfigFromMeta();
  await i18n.init(config);

  if (process.env.NODE_ENV === 'development') {
    global.console.log('Render React App with development config: ', config);
  }

  if (process.env.NODE_ENV === 'production' && config.trackerDSN) {
    Tracker.init(config, {
      release: process.env.VERSION,
      foundation: process.env.LIB_FOUNDATION_VERSION,
    });
  }

  renderApp(config);

  if (window.heap) {
    window.heap.addEventProperties({ module: 'LPB', version: getFieldFromMeta('version') });
  }
};

initApp();
